"use client";

import { useTranslations } from "next-intl";

import { TestimonialsSection } from "@/components/home/testimonials-section";
import type { GoogleReviewsPayload } from "@/lib/google-reviews";

export const HomeTestimonials = ({
  initialGoogleData,
  onMetaUpdate,
}: {
  initialGoogleData?: GoogleReviewsPayload | null;
  onMetaUpdate?: (meta: { rating: number | null; count: number | null; googleMapsUrl?: string }) => void;
}) => {
  const t = useTranslations();
  return <TestimonialsSection t={t} initialGoogleData={initialGoogleData} onMetaUpdate={onMetaUpdate} />;
};
